"use client"; // Error boundaries must be Client Components

import NextError from "next/error";
import { usePostHog } from "@posthog/next";
import { useEffect } from "react";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const posthog = usePostHog();

  useEffect(() => {
    posthog?.captureException(error);
  }, [error, posthog]);

  return (
    // Route error boundary should NOT include html and body tags
    <NextError statusCode={0} />
  );
}
